import { Box } from "@mui/material";
import FiltroDeData from '../Dashboard/FiltroDeData';
import GraficoLeadsPorEtapa from "../Dashboard/GraficoLeadsPorEtapa";
import GraficoMotivoDescarte from "../Dashboard/GraficoMotivoDescarte";
import GraficoVolumeAtendimentos from "./AssistentePreVendaDashboard/GraficoVolumeAtendimentos/ModeloGrafico";

// import GraficoQualificacaoPorEmpreendimento from "../Charts/GraficoQualificacaoPorEmpreendimento";

const DashboardTab = ({
  dateFilter,
  setDateFilter,
  tempDateFilter,
  setTempDateFilter,
  tempStartDate,
  setTempStartDate,
  tempEndDate,
  setTempEndDate,
  handleApplyFilters,
  loadingChart,
  aggregatedChartData,
  totalLeads,
  conversionRate,
  aggregatedDiscardData,
  onYearChange,          // NOVA prop
}) => {
  const tooltipTextLeadsPorEtapa = "Mostra a quantidade de leads em cada etapa do funil no período selecionado — do primeiro contato até a qualificação ou o descarte.";
  const tooltipTextVolumeAtendimentos = "Mostra a quantidade de atendimentos iniciados pelo cliente ou retomados pelo agente. ";
  const tooltipTextMotivoDescarte = "Mostra a proporção dos motivos de descarte dos leads no período selecionado, indicando por qual motivo a conversa foi encerrada.";

  return (
    <>
      <FiltroDeData
        startDate={tempStartDate}
        setStartDate={setTempStartDate}
        endDate={tempEndDate}
        setEndDate={setTempEndDate}
        setDateFilter={setTempDateFilter}
        dateFilter={tempDateFilter}
        handleApplyFilters={handleApplyFilters}
        onYearChange={onYearChange}   // NOVO
      />

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 1, pb: 2 }}>
        <GraficoLeadsPorEtapa
          aggregatedChartData={aggregatedChartData}
          totalLeads={totalLeads}
          conversionRate={conversionRate}
          loading={loadingChart}
          tooltipText={tooltipTextLeadsPorEtapa}
        />

        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 2 }}>
          {/*<GraficoQualificacaoPorEmpreendimento qualificacaoPorEmpreendimento={qualificacaoPorEmpreendimento} />*/}
          <Box sx={{ flex: { xs: '1 1 auto', md: '1 1 70%' }, minWidth: 0 }}>
            <GraficoVolumeAtendimentos tooltipText={tooltipTextVolumeAtendimentos} />
          </Box>
          <Box sx={{ flex: { xs: '1 1 auto', md: '1 1 30%' }, minWidth: 0 }}>
            <GraficoMotivoDescarte
              aggregatedDiscardData={aggregatedDiscardData}
              loading={loadingChart}
              tooltipText={tooltipTextMotivoDescarte}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default DashboardTab;
